<template>
  <!--
    TASK-SF-07 -- DESIGN-04/05/09 progress indicator. A CONTINUOUS bar
    (not Stepper.vue's numbered circles, which are shared elsewhere and
    render a different shape). The step badge lives inside this
    aria-live="polite" region so a step change -- and the clearing of
    dependent selects announced alongside it -- is read out.
    Persian-digit display is a presentation concern (02_* §9.0.4).
  -->
  <div class="onboarding-progress" role="group" :aria-label="ariaLabel">
    <div class="onboarding-progress__row">
      <span
        class="onboarding-progress__badge"
        aria-live="polite"
        data-testid="onboarding-step-badge"
        >{{ badge }}</span
      >
    </div>
    <div
      class="onboarding-progress__track"
      role="progressbar"
      :aria-valuemin="1"
      :aria-valuemax="total"
      :aria-valuenow="step"
    >
      <div
        class="onboarding-progress__fill"
        :style="{ width: fillPercent + '%' }"
        data-testid="onboarding-progress-fill"
      ></div>
    </div>
  </div>
</template>

<script>
const FA_DIGITS = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']
function toFa(n) {
  return String(n).replace(/\d/g, d => FA_DIGITS[+d])
}

export default {
  name: 'OnboardingProgress',
  props: {
    step: { type: Number, required: true },
    total: { type: Number, default: 3 },
  },
  computed: {
    fillPercent() {
      return Math.round((this.step / this.total) * 100)
    },
    badge() {
      return this.$t('login.studentOnboarding.stepBadge', {
        step: toFa(this.step),
        total: toFa(this.total),
      })
    },
    ariaLabel() {
      return this.$t('login.studentOnboarding.progressLabel')
    },
  },
}
</script>

<style lang="scss" scoped>
// TASK-SF-07 visual parity: prototype `.progress` + `.step-count`. Existing
// tokens only -- the indigo→teal fill is $c-information-blue → $c-success-green
// (the token set's own teal); no new token is introduced.
.onboarding-progress {
  margin-bottom: 24px;
}
.onboarding-progress__row {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}
// Prototype `.step-count`: an indigo pill, not plain helper text.
.onboarding-progress__badge {
  background: rgba($c-information-blue, 0.08);
  border-radius: 999px;
  color: $c-information-blue;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
  padding: 6px 10px;
}
.onboarding-progress__track {
  height: 5px;
  border-radius: 99px;
  background: $c-border-grey;
  overflow: hidden;
}
.onboarding-progress__fill {
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, $c-information-blue, $c-success-green);
  transition: width 0.25s ease;
}
</style>
